import styled from 'styled-components'
import breakpoint from 'components/breakpoint'
import ButtonView from 'components/button/ButtonView'

const getAnimation = props =>
  !props.disabled &&
  props.isAnimated &&
  `
  position: relative;
  z-index: 0;
  overflow: hidden;
  
  // prevent hover effect on touch screen devices. Fix ios double click bug
  // not supported by ie
  @media (hover) {
    &:before {
      content: '';
      position: absolute;
      top: 0;
      right: -50px;
      bottom: 0;
      left: 0;
      border-right: 50px solid transparent;
      border-bottom: 50px solid #000;
      -webkit-transform: translateX(-100%);
      transform: translateX(-100%);
      -webkit-transition: 0.5s ease-in-out;
      transition: 0.5s ease-in-out;
      z-index: -1;
    }
  
    &:hover:before {
      transform: translateX(0);
    }
}
  
`
const StyledButtonView = styled(ButtonView)`
  ${breakpoint('portrait')`
     width: 100%;
  `};

  ${getAnimation};
`

export default StyledButtonView
